import { jsxs as h, jsx as a, Fragment as f } from "react/jsx-runtime";
import * as p from "@radix-ui/react-toast";
import { clsx as o } from "clsx";
import * as N from "@radix-ui/react-checkbox";
import { forwardRef as t } from "react";
const B = ({
  open: i,
  message: r,
  actionMessage: n,
  onActionClick: c,
  onOpenChange: d,
  duration: u,
  className: m,
  slots: e,
  closeButton: b
}) => /* @__PURE__ */ h(p.Provider, { swipeDirection: "right", children: [
  /* @__PURE__ */ h(
    p.Root,
    {
      open: i,
      onOpenChange: d,
      duration: u,
      className: o(e == null ? void 0 : e.root, m),
      children: [
        /* @__PURE__ */ a("p", { className: e == null ? void 0 : e.message, children: r }),
        /* @__PURE__ */ h("div", { className: o(e == null ? void 0 : e.actionsWrapper), children: [
          n && c && /* @__PURE__ */ h(f, { children: [
            /* @__PURE__ */ a(
              "button",
              {
                onClick: c,
                className: e == null ? void 0 : e.action,
                "aria-label": "Action",
                role: "button",
                style: {
                  border: "none",
                  background: "none",
                  cursor: "pointer"
                },
                children: n
              }
            ),
            /* @__PURE__ */ a("div", { className: e == null ? void 0 : e.divider, "aria-hidden": "true" })
          ] }),
          /* @__PURE__ */ a(p.Close, { asChild: !0, "aria-label": "Close", className: e == null ? void 0 : e.close, children: b ?? /* @__PURE__ */ a("button", { type: "button", children: "Close" }) })
        ] })
      ]
    }
  ),
  /* @__PURE__ */ a(p.Viewport, { className: e == null ? void 0 : e.viewport })
] }), C = t(
  ({ className: i, slots: r, children: n, ...c }, d) => /* @__PURE__ */ a(
    N.Root,
    {
      ref: d,
      className: o(r == null ? void 0 : r.root, i),
      ...c,
      children: /* @__PURE__ */ a(N.Indicator, { className: r == null ? void 0 : r.indicator, children: n })
    }
  )
);
C.displayName = "BaseCheckbox";
const x = "--mic-loudness";
function M(i, r) {
  if (!i) return;
  const n = Number.isFinite(r) ? Math.min(Math.max(r, 0), 1) : 0;
  i.style.setProperty(x, n.toFixed(3));
}
function R({
  ref: i,
  restHeightsPx: r,
  maxHeightPx: n,
  slots: c,
  className: d,
  ...u
}) {
  return /* @__PURE__ */ a("div", { ref: i, className: d, ...u, children: r.map((m, e) => {
    const b = n - m;
    return /* @__PURE__ */ a(
      "span",
      {
        className: c == null ? void 0 : c.bar,
        style: {
          height: `calc(${m}px + var(${x}, 0) * ${b}px)`
        }
      },
      e
    );
  }) });
}
export {
  B,
  x as M,
  C as a,
  R as b,
  M as s
};
//# sourceMappingURL=BaseVoiceIndicator-CyMk5WtB.js.map
